import { render } from "./ClockpickerFooter.vue?vue&type=template&id=7230c859"
import script from "./ClockpickerFooter.vue?vue&type=script&lang=js"
export * from "./ClockpickerFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Forms/TimePicker/ClockpickerFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7230c859"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7230c859', __exports__)) {
    api.reload('7230c859', __exports__)
  }
  
  module.hot.accept("./ClockpickerFooter.vue?vue&type=template&id=7230c859", () => {
    api.rerender('7230c859', render)
  })

}


export default __exports__